import { ComprehendServiceException as __BaseException } from "./ComprehendServiceException";
export class ConcurrentModificationException extends __BaseException {
    name = "ConcurrentModificationException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "ConcurrentModificationException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, ConcurrentModificationException.prototype);
        this.Message = opts.Message;
    }
}
export class TooManyTagKeysException extends __BaseException {
    name = "TooManyTagKeysException";
    $fault = "client";
    Message;
    constructor(opts) {
        super({
            name: "TooManyTagKeysException",
            $fault: "client",
            ...opts,
        });
        Object.setPrototypeOf(this, TooManyTagKeysException.prototype);
        this.Message = opts.Message;
    }
}
